export const environment = {
  production: true,
  url: 'https://web.totaldocs.com/',
  server: 'https://web.totaldocs.com/totaldocs-app-server-angular/',
  ambiente: 'PRODUCAO',
  idDocumentoAssinatura: 5158899,
  analytics: 'UA-157293812-1',
  recaptcha: '6LelqdoZAAAAAI2p6P7N4yKtOZ0ucjJwjT0hP3Yq'
};
